export default __webpack_public_path__ + "1282166.png";